import {api} from "@/config";
import {endpoints} from "@/constants";

export const vendorReport = {
    url() {
        return `${baseUrl}vendor-report`;
    },
    namespaced: true,
    state: {
        vendors: [],
    },
    mutations: {
        setVendors: (state, vendors) => {
            state.vendors = vendors;
        },
    },
    actions: {
        get({context}) {
            return api.get(vendorReport.url());
        },
        async getStoreNames({commit, rootGetters}) {
            try {
                if (rootGetters.isSuperAdmin) {
                    const {data} = await api.get(endpoints.superAdmin.getStoreNames);
                    commit("setVendors", data.data);
                    return data;
                }

                return {data: []};
            } catch (error) {
                console.error("Failed to fetch store names:", error);
                return {data: []};
            }
        },
    },
};
